export default __webpack_public_path__ + "static/media/FranticVelvet1.1a7ee6fd.jpg";